import axios from "axios";
import { Img } from "../Img/index";
import Modal from "react-modal";
import { renderBaseUrlForApi } from "../../utils/index";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "20rem",
        minHeight: "25rem",
        maxHeight: "25rem",
        borderRadius: "1.5em",
        boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
        padding: "1.3em",
        background: "white",
        // background:
        //   "linear-gradient(120deg, #C7366B 10%, #9F33AC 50%, #8532D7 90%)",
    },
    overlay: {
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: 999,
    },
};

const getRandomColor = () => {
    const colors = ['bg-red-500', 'bg-blue-500', 'bg-green-500', 'bg-yellow-500', 'bg-purple-500', 'bg-pink-500'];
    return colors[Math.floor(Math.random() * colors.length)];
};

function extractPageLink(text) {
  const regex = /\[\s*['"]([^'"]+)['"]\s*\]/;
  const match = text.match(regex);
  return match ? match[1] : null;
}

const parseStringToJSX = (inputString) => {
    // Extracting the text before the clickable text
    const beforeClickableText = inputString?.split(':[')[0];

    // Extracting the clickable text and hyperlink
    const match = inputString?.match(/\((.*?)\):\["(.*?)"\]/);
    const clickableText = match ? match?.[1] : 'Click here';

    const link = extractPageLink(inputString);

    // Extracting the remaining text after the hyperlink
    const afterLink = inputString?.split('] ')?.[1];

    return (
        <p className="text-[1.8vh]">
            {beforeClickableText?.split("(")?.[0]} <button type="button" onClick={() => window.open(link,"_blank")} className="text-[blue] underline">{clickableText}</button> {afterLink}
        </p>
    );
};

const SocialHubCard = ({ element, listData, handleGoogleSelection, handleInstituteSelection, loader }) => {

    function openPopUp() {
        const redirectUri = encodeURIComponent(`https://soomuch.ai/meta_auth`);
        const facebookUrl = 'https://www.facebook.com/v19.0/dialog/oauth?client_id=798892955436817&redirect_uri=' + redirectUri + '&response_type=token&scope=pages_manage_posts,pages_show_list,instagram_basic,instagram_content_publish,business_management,pages_manage_metadata';

        window.open(facebookUrl, "_blank", "width=650,height=700")
    }

    const handleGoogleAuthFlow = () => {
        const request = async () => {
            const authResponse = await axios.post(`${renderBaseUrlForApi()}/comm/google/auth?env=onboarding`);
            let newwindow: any = window.open(authResponse?.data?.data?.auth_url, "google auth", 'width=600,height=400');
            if (window.focus as any) { newwindow.focus() }
            // setSocialHubStatus(data);
        };
        request();
    }

    const getModalStyles = () => {
        if (window.matchMedia("(max-width: 768px)").matches) {
            // Apply smaller styles for mobile and tablet
            return {
                ...customStyles,
                content: {
                    ...customStyles.content,
                    width: "90%", // Set to a percentage or auto
                },
            };
        }
        // Default styles for larger screens
        return customStyles;
    };


    return (
        <>
            <Modal
                isOpen={!!(listData?.data?.list || listData?.data)?.length}
                contentLabel="Example Modal"
                style={getModalStyles()}
            >
                <div className="space-y-4">
                    <div className='flex flex-col justify-center items-center'>
                        {loader ? <Img src={"/images/loader.gif"} className="w-10 h-10 mb-2" />: <h2 className="text-xl text-center font-semibold mb-4">
                            Please select the {['Youtube'].includes(element?.name) ? "channel" : ['Google Business'].includes(element?.name) ? "Business Account" : "page"}.
                        </h2>}
                        <div className="space-y-4 max-h-[270px] overflow-auto w-full">
                            {['Google Business', 'Youtube'].includes(element?.name) ? listData?.data?.list?.map((google, index) => {
                                const firstLetter = (google?.snippet?.title || google?.title)?.charAt(0).toUpperCase();
                                const randomColor = getRandomColor();
                                return (
                                    <div key={"asdkajskdhqwkjebqnsadasdsad" + index} className='text-[1.8vh] flex justify-between items-center'>
                                        <div key={index} className="flex items-center space-x-4">
                                            {['Youtube'].includes(element?.name) ? <div className={`flex items-center justify-center w-10 h-10 text-white font-bold rounded-full overflow-clip`}>
                                                <Img src={google?.snippet?.thumbnails?.default?.url} alt={'image'} className='object-fit w-10 h-10' />
                                            </div> : <div className={`flex items-center justify-center w-10 h-10 text-white font-bold rounded-full overflow-clip ${randomColor}`}>
                                                {firstLetter}
                                            </div>}
                                            <div>
                                                <p className="font-medium">{google?.snippet?.title || google?.title}</p>
                                            </div>
                                        </div>
                                        <button disabled={loader} onClick={() => handleGoogleSelection(google)} className='text-primary-main font-semibold border border-solid py-1 px-3 rounded-lg' type="button">Select</button>
                                    </div>
                                );
                            }) : listData?.data?.map((school, index) => {
                                const firstLetter = school?.name?.charAt(0).toUpperCase();
                                const randomColor = getRandomColor();

                                return (
                                    <div key={"asdkajskdhqwkjebqnsad" + index} className='text-[1.8vh] flex justify-between items-center w-full'>
                                        <div key={index} className="flex justify-between items-center space-x-4">
                                            <div className={`flex items-center justify-center w-10 h-10 text-white font-bold rounded-full overflow-clip ${randomColor}`}>
                                                {!!school?.page_logo_url ? <Img src={school?.page_logo_url} alt={'image'} className='object-fit w-10 h-10' /> : firstLetter}
                                            </div>
                                            <div>
                                                <p className="font-medium">{school?.name}</p>
                                                {!['Google Business', 'Youtube'].includes(element?.name) && <p className="text-[1.8vh] text-gray-500">{school?.page_likes} Likes · {school?.category}</p>}
                                            </div>
                                        </div>
                                        <button disabled={loader} onClick={() => handleInstituteSelection(school)} className='text-primary-main font-semibold border border-solid py-1 px-3 rounded-lg' type="button">Select</button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Modal>
            <div className="rounded-lg shadow-lg py-2 px-4 flex flex-col gap-2">
                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <Img src={element?.icon} className={element?.icon?.split(".")?.[1] === "svg" ? "w-[4vh] h-[4vh]" : "h-[5vh]"} />
                        <span className="text-[1.8vh]">{element?.name}</span>
                    </div>
                    <button
                        onClick={() => {
                            sessionStorage.setItem('selectedSocialMedia', JSON.stringify(element));
                            if (['Facebook', 'Instagram'].includes(element?.name)) {
                                openPopUp();
                            } else if (['Google Business', 'Youtube'].includes(element?.name)) {
                                handleGoogleAuthFlow()
                            }
                        }}
                        type="button"
                        disabled={element?.status === "CONNECTED" || ['li','ylp'].includes(element.id)}
                        className={`border border-gray-300 rounded-full py-1 px-2 flex justify-center items-center gap-2 ${element?.status === "CONNECTED" && "bg-green-600 text-[white]"}`}
                    >
                        {['li','ylp'].includes(element.id) ? <span className="text-[1.5vh]">Coming Soon</span> : <>
                        {!(element?.status === "CONNECTED") && <Img src="/images/plus.svg" className="w-[2.6vh] h-[2.6vh]" />}
                        <span className="text-[1.5vh]">{!(element?.status === "CONNECTED") ? "Connect" : "Connected"}</span>
                        </>}
                    </button>
                </div>
                <hr />
                <div>
                    {parseStringToJSX(element?.description)}
                </div>
            </div>
        </>
    );
}

export default SocialHubCard;